<template>
  <div>
    <!-- 面包屑导航区 -->
    <!--    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>农场管理</el-breadcrumb-item>
      <el-breadcrumb-item>餐品列表</el-breadcrumb-item>
    </el-breadcrumb> -->
    <!-- 卡片视图 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            placeholder="请输入内容"
            v-model="queryInfo.query"
            clearable
            @clear="getFoodList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getFoodList"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="goAddPage">添加餐品</el-button>
        </el-col>
      </el-row>
      <!-- 表格数据 -->
      <el-table :data="FoodList" border stripe>
        <!-- <el-table-column type="index"></el-table-column> -->
        <el-table-column
          label="餐品名称"
          width="150px"
          prop="name"
        ></el-table-column>
        <el-table-column label="餐品图片" width="125px">
          <template slot-scope="scope"
            ><img :src="scope.row.image" width="100px" height="100px"
          /></template>
        </el-table-column>
        <el-table-column label="餐品价格(元)" width="150px">
          <template slot-scope="scope">
            {{ $round(scope.row.price) }}
          </template>
        </el-table-column>
        <el-table-column label="餐品规格" width="150px">
          <template slot-scope="scope">
            <el-tag type="success" size="mini">{{
              scope.row.specification
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="餐品介绍">
          <template slot-scope="scope">{{
            scope.row.description
              ? scope.row.description.substring(0, 10) + "..."
              : "--"
          }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="180px">
          <template slot-scope="scope">{{
            scope.row.create_time | dataFormat
          }}</template>
        </el-table-column>
        <el-table-column label="状态" width="180px">
          <template slot-scope="scope">
            <el-tag type="success" size="mini" v-if="scope.row.status"
              >已上架</el-tag
            >
            <el-tag type="danger" size="mini" v-else>已下架</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300px" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status"
              type="danger"
              icon="el-icon-down"
              size="mini"
              @click="updateStatus(scope.row.id, 0)"
              >下架</el-button
            >
            <el-button
              v-if="!scope.row.status"
              type="success"
              icon="el-icon-up"
              size="mini"
              @click="updateStatus(scope.row.id, 1)"
              >上架</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="editInfo(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="removeById(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>
    </el-card>
    <el-dialog
      :title="isEdit ? '修改餐品信息' : '添加餐品信息'"
      :visible.sync="editDialogVisible"
      width="50%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <AddProduct
        :detail="currentDetail"
        :isEdit="isEdit"
        @refreshList="refreshList"
        @close="editDialogVisible = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import { farm_FoodList } from "@/config/config.js";
import AddProduct from "./Add.vue";
export default {
  components: {
    AddProduct,
  },
  data() {
    return {
      queryInfo: {
        query: "",
        page: 1,
        limit: 10,
        status: -1,
      },
      // 餐品列表
      FoodList: [],
      // 餐品总数
      total: 0,
      editDialogVisible: false,
      currentDetail: null,
      isEdit: false,
      farmList: [],
    };
  },
  created() {
    this.getFoodList();
    // this.getDictionaryList();
    this.getFarmList();
  },
  methods: {
    refreshList() {
      this.getFoodList();
      this.editDialogVisible = false;
    },
    async getDictionaryList() {
      this.$getDicList(13).then((list) => {
        this.FoodTypeList = list;
      });
    },
    // 根据分页获取对应的餐品列表
    async getFoodList() {
      let params = _.cloneDeep(this.queryInfo);
      params.page--;
      const { data: res } = await this.$http.get("web_api/canteen/foods", {
        params,
      });
      if (res.code !== 200) {
        return this.$message.error("获取列表失败！");
      }
      this.FoodList =
        res.data && typeof res.data == "object" ? res.data : supplierList;
      this.total = res.total || this.FoodList.length;
    },
    // 根据分页获取对应的农场列表
    async getFarmList() {
      const { data: res } = await this.$http.get("openapi/web_proxy_get", {
        params: {
          page: 0,
          limit: 100,
          action: "farmList",
          path: "ashx/farm.ashx",
          status: 1,
        },
      });
      if (res.code !== 200) {
        return this.$message.error("获取农场列表失败！");
      }
      this.farmList = res.data;
    },
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize;
      this.getFoodList();
    },
    handleCurrentChange(newSize) {
      this.queryInfo.page = newSize;
      this.getFoodList();
    },
    // 通过Id删除餐品
    async removeById(id) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该餐品, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已取消删除！");
      }
      const { data: res } = await this.$http.post("web_api/canteen/deleteFood", {
        id
      });
      if (res.code !== 200) {
        return this.$message.error("删除餐品失败！");
      }
      this.$message.success("删除餐品成功！");
      this.getFoodList();
    },
    goAddPage() {
      this.isEdit = false;
      this.currentDetail = null;
      this.editDialogVisible = true;
    },
    async updateStatus(id, flag) {
      const confirmResult = await this.$confirm(
        `是否确认${flag == 0 ? "下架" : "上架"},?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已取消操作！");
      }
      const { data: res } = await this.$http.post("web_api/canteen/updateFoodStatus", {
        id,
        status: flag,
      });
      if (res.code !== 200) return this.$message.error("更新餐品状态失败！");
      this.$message.success("更新餐品状态成功!");
      this.getFoodList();
    },
    editInfo(current) {
      this.isEdit = true;
      this.currentDetail = current;
      this.editDialogVisible = true;
    },
    closeDialog() {
      this.isEdit = false;
      this.currentDetail = null;
      this.editDialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped></style>
